// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2fdc7d3b","494":"a58245cd","707":"384cd0d2"}[chunkId] + ".chunk.js";
};